import readingPaneStore from '../store/Store';
import { action } from 'satcheljs/lib/legacy';
export default action('setItemReadingPaneViewState')(function setItemReadingPaneViewState(viewState) {
    readingPaneStore.itemReadingPaneViewState = viewState;
});
//# sourceMappingURL=setItemReadingPaneViewState.js.map